import { ISSRPageData } from '@interfaces'
import { ObjectService } from '@services'
import { ObjectTemplate } from '@templates'
import { createNavLink } from '@utils'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'

const ObjectOfArtistScreen = ({ pageData, global }: ISSRPageData) => {
  const { locale, query } = useRouter()
  const { t } = useTranslation()

  return (
    <ObjectTemplate
      global={global}
      pageData={pageData}
      headerLeftNavButtonLabel={t('common:goBackButtonLabel')}
      headerLeftNavButtonHref={`${createNavLink('artist', locale)}/${
        query?.id
      }`}
    />
  )
}

export default ObjectOfArtistScreen

/**
 * slug is collection sourceId
 * object is object of collection sourceId
 */
interface ISSRProps {
  query: {
    id: string
    object: string
  }
  locale: string
}

export async function getServerSideProps({ query, locale }: ISSRProps) {
  const { object, id } = query
  const pageData = {
    data: null,
    error: null,
  }

  try {
    const collection = await ObjectService.getObjectDetailPage(
      object,
      locale,
      'artist',
      id
    )

    pageData.data = collection
  } catch (err) {
    if (err instanceof Error) {
      pageData.error = { message: err.message }
    }
  }

  if (!pageData.data && !pageData.error) {
    pageData.error = { message: 'Object not found' }
  }

  return {
    props: { pageData },
  }
}
